import { LeavePanel, type LeaveSource } from '@/features/institute/staff/components/StaffLeaveTab';
import { myLeaveApi } from '../../api/myLeave.api';

/** Built once: the person never changes while the page is open. */
const OWN_LEAVE: LeaveSource = {
  key: 'me',
  load: myLeaveApi.get,
  apply: myLeaveApi.apply,
  withdraw: myLeaveApi.withdraw,
};

export interface MyLeavePanelProps {
  isFormOpen?: boolean;
  onFormOpenChange?: (open: boolean) => void;
  yearUuid?: string;
  onYearChange?: (yearUuid: string) => void;
  onAcademicYearsLoaded?: (years: { uuid: string; name: string; isCurrent: boolean }[]) => void;
}

/**
 * A teacher's own leave: the balance, what they have applied for, and the form.
 *
 * The office's leave panel, pointed at the teacher's own record — so the two
 * read the same balance the same way, and an application made here is the row
 * the office decides on Staff Attendance → Leave.
 */
export function MyLeavePanel({
  isFormOpen,
  onFormOpenChange,
  yearUuid,
  onYearChange,
  onAcademicYearsLoaded,
}: MyLeavePanelProps = {}) {
  return (
    <LeavePanel
      source={OWN_LEAVE}
      staffName="you"
      isOwn
      isFormOpen={isFormOpen}
      onFormOpenChange={onFormOpenChange}
      yearUuid={yearUuid}
      onYearChange={onYearChange}
      onAcademicYearsLoaded={onAcademicYearsLoaded}
      hideYearSelector={Boolean(onAcademicYearsLoaded)}
    />
  );
}
